<template>
  <h1 id="page-title">Comentários</h1>
  <el-timeline id="comments">
    <section v-for="comment in comments.items" :key="comment">
      <el-timeline-item
        :timestamp="convertToLocalTimezone(comment.created_at)"
        placement="top"
      >
        <el-card>
          <p>
            <span v-if="comment.book_title != null">
              Comentário feito em
              <a @click="redirectBookDetail(comment.book_id.$oid)">{{
                comment.book_title
              }}</a>
            </span>
            <span v-else>
              <a @click="redirectBookDetail(comment.book_id.$oid)">
                Ir para o livro
              </a>
            </span>
          </p>
          <p>{{ comment.body }}</p>
          <h4 v-if="comment.username">@{{ comment.username }}</h4>
        </el-card>
      </el-timeline-item>
    </section>
  </el-timeline>
  <el-pagination
    layout="total, prev, pager, next"
    :total="comments.count"
    @current-change="handleCurrentChange"
  >
  </el-pagination>
</template>

<script>
import { getUserComments } from "../../services/comment";
export default {
  name: "Comments",
  components: {},

  data() {
    return {
      comment: {
        body: "",
      },
      comments: {},
      currentPage: 1,
    };
  },

  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserComments();
      const el = document.getElementById("pageTitle");
      el.scrollIntoView({ behavior: "smooth" });
    },

    getUserComments() {
      const params = {
        per_page: 10,
      };
      params.page = this.currentPage;
      getUserComments(this.$store.state.user._id.$oid, params).then(
        (response) => {
          this.comments = response.data;
        }
      );
    },

    redirectBookDetail(bookId) {
      this.$router.push(`/books/${bookId}`);
    },

    convertToLocalTimezone(UTCDate) {
      var date = new Date(UTCDate);
      return (
        String("0" + date.getDate()).slice(-2) +
        "/" +
        String("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        String(date.getFullYear()) +
        " - " +
        String("0" + date.getHours()).slice(-2) +
        ":" +
        String("0" + date.getMinutes()).slice(-2)
      );
    },
  },

  created() {
    this.getUserComments();
  },
};
</script>
<style scoped>
a {
  text-decoration: underline;
  cursor: pointer;
}

#page-title {
  text-align: center;
}
</style>
